<div @show class="body" [formGroup]="formGroup">

    <div class="calendar-wrapper" #calendarWrapper formArrayName="appointments">

        <full-calendar #calendar [options]="calendarOptions" class="calendar"></full-calendar>

        <div class="overlay" *ngIf="appointmentsControl.controls[currentTaskIndex]" (click)="closeEventDialog()">

            <div class="spacer"></div>

            <div class="overlay-inner" (click)="$event.stopPropagation()">

                <mat-toolbar class="ams-toolbar">
                    <mat-icon class="main-icon">today</mat-icon>
                    <span>Ereignis bearbeiten</span>
                    <span class="spacer"></span>
                    <button mat-icon-button (click)="deleteEvent()" color="warn">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-toolbar>

                <div class="content-wrapper" [formGroupName]="currentTaskIndex">

                    <app-event-form></app-event-form>

                </div>

                <div class="footer">

                    <div class="spacer"></div>

                    <button mat-icon-button color="warn" (click)="deleteEvent()">
                        <mat-icon>delete_forever</mat-icon>
                    </button>

                    <button mat-raised-button color="primary" (click)="saveEvent()">
                        Speichern
                    </button>

                </div>

            </div>

            <div class="spacer"></div>

        </div>

    </div>

</div>